/*Budget*/
if(window.location.pathname.includes("placement/budget")){        
    
}


// WEBPACK FOOTER //
// ./resources/assets/js/pages/budget.js